export const ACTIVE_STORE_ID_KEY = 'activeStoreId';
export const ACTIVE_STORE_CHANGED_EVENT = 'active-store-changed';

export const getActiveStoreId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(ACTIVE_STORE_ID_KEY);
};

export const setActiveStoreId = (storeId: string): void => {
  localStorage.setItem(ACTIVE_STORE_ID_KEY, storeId);
  window.dispatchEvent(new Event(ACTIVE_STORE_CHANGED_EVENT));
};

export const clearActiveStoreId = (): void => {
  localStorage.removeItem(ACTIVE_STORE_ID_KEY);
  window.dispatchEvent(new Event(ACTIVE_STORE_CHANGED_EVENT));
};
